<template>
  <div>
    <JqxWindow ref="myWindow" :theme="'material'" :width="930" :height="650" :resizable="true" :isModal="true"
               :autoOpen="false" :initContent="init">
      <div class="col-md"><strong>Articoli</strong>
      </div>
      <div>
        <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false">
          <ul id="muoviti" style="margin-left: 5px">
            <li>Dati generali</li>
            <li>Extra</li>
          </ul>
          <div>
            <JqxSplitter ref="splitter" :width="850" :heigth="600" :autoCreate="false" :panels="panels">
              <div class="splitter-panel" :theme="'material'">
                <div style="margin-top: 5px;margin-left: 5px;">

                  <div class="form-group">
                    <label>Impianto depositante *</label>
                    <br>
                    <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="impianto_depositante"
                                 :popupZIndex="10000" :displayMember="'ragione_sociale'"
                                 :valueMember="'id'"
                                 :source="dataAdapterImpianti" :theme="'material'"></JqxComboBox>
                  </div>
                  <div class="form-group">
                    <label>Articolo *</label>
                    <br>
                    <JqxInput v-if="checkNew" :theme="'material'" ref="articolo"></JqxInput>
                    <JqxInput readonly v-else :theme="'material'" ref="articolo"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>U.M. *</label>
                    <br>
                    <JqxInput :theme="'material'" ref="unita_di_misura"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Quantità per UDC *</label>
                    <br>
                    <JqxInput :theme="'material'" ref="quantita_per_udc"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Descrizione articolo *</label>
                    <br>
                    <JqxInput :theme="'material'" ref="descrizione_articolo"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Matrice brand</label>
                    <br>
                    <JqxInput :theme="'material'" ref="brand_matrice"></JqxInput>
                  </div>
                </div>
              </div>
              <div class="splitter-panel">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Articolo fornitore</label>
                    <br>
                    <JqxInput :theme="'material'" ref="articolo_fornitore"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Barcode fornitore</label>
                    <br>
                    <JqxInput :theme="'material'" ref="barcode_fornitore"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Descrizione fornitore</label>
                    <br>
                    <JqxInput :theme="'material'" ref="descrizione_fornitore"></JqxInput>
                  </div>

                  <div class="form-group">
                    <label>Codice opzionale</label>
                    <br>
                    <JqxInput :theme="'material'" ref="codice_opzionale"></JqxInput>
                  </div>
                  <!--<div class="form-group">
                    <label>Quantità in giacenza</label>
                    <br>
                    <JqxInput :theme="'material'" ref="quantita"></JqxInput>
                  </div>-->
                </div>
              </div>
            </JqxSplitter>
          </div>
          <div>
            <div class="form-group">
              <label>Note interne</label>
              <br>
              <JqxInput :theme="'material'" ref="note_interne"></JqxInput>
            </div>
          </div>
        </JqxTabs>
        <card>
          <div class="float-right">
            <JqxButton :theme="'material'" @click="saveParent">
              Save
            </JqxButton>

            <JqxButton :theme="'material'" @click="cancelParent">
              Cancel
            </JqxButton>
          </div>
        </card>
      </div>
    </JqxWindow>
  </div>
</template>

<script>
  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";

  export default {
    name: "ArticoliDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxSplitter,
      JqxTabs,
      JqxComboBox,
      JqxCheckBox
    },
    data: function () {
      return {
        panels: [{size: 200}, {size: 200}],
        dataAdapterImpianti: new jqx.dataAdapter(this.sourceanagraficaimpianti),
        checkNew: true

      }
    },
    beforeCreate: function () {
      this.sourceanagraficaimpianti = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaImpianti&q=allforsourceinput'
      };
    },
    mounted: function(){
      let codice_articolo = this.$refs.articolo.val()
      //console.log(codice_articolo)
    },
    methods: {
      saveParent() {
        let impianto_depositante = this.$refs.impianto_depositante.val();
        let articolo = this.$refs.articolo.val();
        let unita_di_misura = this.$refs.unita_di_misura.val();
        let descrizione_articolo = this.$refs.descrizione_articolo.val();
        //console.log(impianto_depositante)
        //console.log(articolo)
        //console.log(unita_di_misura)
        //console.log(descrizione_articolo)

        if(!impianto_depositante || !articolo || !unita_di_misura || !descrizione_articolo){
          alert('Attenzione! Mancano dei campi obbligatori. Assicurarsi di aver compilato "Impianto depositante", "Articolo", "U.M." e "Descrizione articolo" per continuare.')
        }
        else {
          this.$parent.saveBtn();
        }
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
      newRowCheckGrid: function (isNew) {
        this.checkNew = isNew == 1 ? true : false

      },
      init: function () {
        let options = {height: "80%", theme: "material"};
        this.$refs.tab.createComponent(options);
        let tmp = {width: "98%", height: "98%", theme: "material"};
        this.$refs.splitter.createComponent(tmp);
      },
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
